export default __webpack_public_path__ + "static/media/halonasoft-picturemark-l.21d5b36a.svg";